/**
 * GitHub-flavored markdown renderer (marked + GFM).
 */

import { marked } from 'marked';

const ALLOWED_LINK_PREFIX = /^(https?:|mailto:|tel:|#|\/)/i;

marked.setOptions({
  gfm: true,
  breaks: false,
});

marked.use({
  renderer: {
    link({ href, title, text }) {
      const raw = href ?? '';
      const safe = ALLOWED_LINK_PREFIX.test(raw.trim()) ? raw : '#';
      const titleAttr = title ? ` title="${escapeAttr(title)}"` : '';
      return `<a href="${escapeAttr(safe)}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
    },
    image({ href, title, text }) {
      const raw = href ?? '';
      const safe = ALLOWED_LINK_PREFIX.test(raw.trim()) ? raw : '';
      if (!safe) return escapeHtml(text || '');
      const titleAttr = title ? ` title="${escapeAttr(title)}"` : '';
      const alt = escapeAttr(text || '');
      return `<img src="${escapeAttr(safe)}" alt="${alt}"${titleAttr} loading="lazy" />`;
    },
  },
});

/**
 * @param {string} content
 * @returns {string}
 */
export function renderMarkdown(content) {
  if (!content) return '';
  try {
    return marked.parse(content, { async: false });
  } catch {
    const div = document.createElement('div');
    div.textContent = content;
    return `<p>${div.innerHTML.replace(/\n/g, '<br>')}</p>`;
  }
}

function escapeAttr(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
